import script from "./copywritingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./copywritingPage.vue?vue&type=script&setup=true&lang=js"

import "./copywritingPage.vue?vue&type=style&index=0&id=4752158e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4752158e"]])

export default __exports__